import {ACTION_TYPES} from "./types";

export default {
    fetchAttestations() {
        return {
            type: ACTION_TYPES.GET_ATTESTATIONS,
        };
    },
    fetchAttestationSubmition(attestationId: string) {
        return {
            type: ACTION_TYPES.GET_ATTESTATION_SUBMISSION,
            payload: attestationId,
        }
    },
    //@ts-expect-error
    sendAttestationResults({attestationId, answers}) {
        return {
            type: ACTION_TYPES.SEND_ATTESTATION_RESULTS,
            payload: {attestationId, answers},
        }
    },
    getAttestationStatistic(payload?: string) {
        return {
            type: ACTION_TYPES.GET_ATTESTATION_STATISTIC,
            payload,
        }
    }
}